<!--
 * @Author: Lemon C
 * @Date: 2024-12-09 15:25:31
 * @LastEditTime: 2025-01-17 11:19:04
-->
<template>
    <div class="sup-privat-module-comp">
        <div class="re-w1200 re-main-row">
            <img src="@/assets/imgs/product/icon_privat_service.png" alt="" />
            <div class="p-s-box">
                <span class="p-s-title">支持私有化部署，保障数据安全</span>
                <div class="p-s-line"></div>
                <span class="p-s-dis">黑洞引擎提供简单便捷的私有化部署包，杜绝一切数据风险和安全隐患。</span>
            </div>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref } from 'vue';
import { useRouterStore } from '@/stores/router';

const router_store = useRouterStore();

// MARK Click 查看部署流程
const show_deployment_process_click = () => {
    router_store.navigateToToolUseGuide();
};

// MARK Click 联系我们
const contact_us_click = () => {
    router_store.navigateToCantactUs();
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-privat-module-comp {
    position: relative;
    display: flex;
    justify-content: center;

    img {
        position: relative;
        width: 360px;
        height: 310px;
    }

    .p-s-box {
        position: relative;
        margin-left: 133px;
        display: flex;
        flex-direction: column;

        .p-s-title {
            position: relative;
            margin-top: 48px;
            font-weight: 400;
            font-size: 40px;
            color: var(--color-main-text-primary);
        }

        .p-s-line {
            position: relative;
            margin-top: 20px;
            width: 73px;
            height: 7px;
            background: var(--color-main-brand);
            border-radius: 1px;
        }

        .p-s-dis {
            position: relative;
            flex: 1;
            width: 700px;
            margin-top: 53px;
            font-weight: 400;
            font-size: 20px;
            color: var(--color-main-text-secondary);
            line-height: 37px;
        }

    }
}
</style>
